var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.03077 10.4652L9.62 14.0001L17.9692 5.77734L20 7.77734L9.62 18.0001L4 12.4652L6.03077 10.4652Z","fill":"#0BAA5E"}})}
var staticRenderFns = []

export { render, staticRenderFns }